import IconLock from "../../assets/images/icons/lock.svg?react";
import { useTranslate } from "../../hooks/useTranslate";
import "./LockedPage.css";

const LockedPage = (props) => {
    const { isLocked, showPermissionText, children } = props;

    const { t } = useTranslate();

    if (isLocked) {
        return (
            <div className="locked-page">
                <div className="locked-page__image">
                    <IconLock />
                </div>
                <h3 className="locked-page__text">
                    {showPermissionText ? t("common.noPermission") : t("tasks.completeAllAvailableTasksToUnlock")}
                </h3>
            </div>
        );
    }

    return children;
};

export default LockedPage;
